// extracted by mini-css-extract-plugin
module.exports = {"h4":"bandeau-module--h4--ciybZ","bg":"bandeau-module--bg--UFfKf","svg":"bandeau-module--svg--2fwZo"};